import { NavigationExtras } from '@angular/router';
import { createAction, props } from '@ngrx/store';

export const go = createAction('[Router] Go', props<{ path: any[]; query?: object; extras?: NavigationExtras }>());
export const back = createAction('[Router] Back');
export const forward = createAction('[Router] Forward');
export const home = createAction('[Router] Home');
export const reload = createAction('[Router] Reload');
export const setPath = createAction('[Router] Set Path', props<{ path: string }>());
export const clearPath = createAction('[Router] Clear Path');
